import * as React from "react";
import type { SVGProps } from "react";

export function Norway(
  props: SVGProps<SVGSVGElement> & { isVisible: boolean }
) {
  const { isVisible, ...rest } = props;
  const colorUpRef = React.useRef<SVGAnimateElement>(null);
  const transparentUpRef = React.useRef<SVGAnimateElement>(null);
  const colorDownRef = React.useRef<SVGAnimateElement>(null);
  const transparentDownRef = React.useRef<SVGAnimateElement>(null);

  React.useEffect(() => {
    if (isVisible) {
      colorUpRef.current?.beginElement();
      transparentUpRef.current?.beginElement();
    } else {
      colorDownRef.current?.beginElement();
      transparentDownRef.current?.beginElement();
    }
  }, [isVisible]);
  return (
    <svg
      width={400}
      height={400}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <defs>
        <linearGradient id="bottom-to-top" x2="0%" y1="100%">
          <stop offset="0" stopColor="#2EE69F">
            <animate
              ref={colorUpRef}
              dur="2s"
              attributeName="offset"
              fill="freeze"
              from="0"
              to="0.9"
              restart="always"
            />
          </stop>
          <stop offset="0" stopColor="transparent">
            <animate
              ref={transparentUpRef}
              dur="2s"
              attributeName="offset"
              fill="freeze"
              from="0"
              to="0.9"
              restart="always"
            />
          </stop>
        </linearGradient>
        <linearGradient id="top-to-bottom" x2="0%" y1="100%">
          <stop offset="0" stopColor="#2EE69F">
            <animate
              ref={colorDownRef}
              dur="2s"
              attributeName="offset"
              fill="freeze"
              from="0.9"
              to="0"
              restart="always"
            />
          </stop>
          <stop offset="0" stopColor="transparent">
            <animate
              ref={transparentDownRef}
              dur="2s"
              attributeName="offset"
              fill="freeze"
              from="0.9"
              to="0"
              restart="always"
            />
          </stop>
        </linearGradient>
      </defs>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.7323 380.642C51.7552 387.921 61.8532 372.771 82.0207 360.318C99.7189 349.392 87.9724 331.058 99.4335 329.274C108.061 340.179 99.6047 355.707 113.685 364.4C127.786 373.077 122.919 345.317 133.046 333.37C146.398 317.62 143.151 301.863 149.303 287.205C154.105 275.808 144.072 247.834 150.059 224.526C157.888 194.054 171.732 209.29 176.871 194.46C181.224 181.208 164.624 182.193 178.212 160.72C189.324 143.171 191.721 133.901 205.63 121.776C217.263 111.586 212.688 90.369 225.155 86.6224C237.601 82.8401 236.645 90.5617 245.744 87.1434C254.814 83.7322 242.09 68.8884 256.035 63.3292C269.544 57.8984 274.875 78.9436 287.435 81.1773C309.458 85.1452 312.348 59.5255 324.808 54.6442C337.09 49.8343 357.614 76.2461 369.239 59.5255C377.917 47.0796 354.645 43.8183 353.575 38.2305C351.955 29.3742 372.479 24.8569 356.237 11.8544C344.405 2.37723 330.253 17.2923 325.186 14.3664C321.04 11.9828 323.188 0.0507644 297.176 0.471812C277.173 0.79295 268.488 12.9605 255.806 18.9979C242.954 25.1138 230.879 21.3743 221.359 30.8229C209.284 42.8192 219.525 49.2277 208.442 57.0706C201.834 61.6878 191.436 55.7503 170.419 64.9349C153.106 72.528 131.183 91.4181 134.231 98.69C137.328 105.926 181.795 86.08 181.738 94.2726C181.716 100.724 170.198 108.574 154.719 138.083C150.894 145.312 105.2 192.541 106.163 198.407C107.548 206.921 123.44 198.7 130.684 191.684C137.021 185.554 135.843 198.571 126.73 203.552C119.137 207.706 118.916 215.913 114.955 214.628C112.308 213.764 111.558 206.828 102.003 206.906C92.1187 207.006 81.7209 202.368 76.1902 205.536C69.4392 209.376 63.987 216.041 54.2315 220.565C39.6661 227.324 24.7796 233.097 18.8279 241.332C14.1178 247.855 4.28389 271.448 7.84495 276.501C10.3926 280.112 16.744 274.966 25.2007 278.727C30.817 281.211 47.1522 278.727 47.5947 280.504C47.9087 281.731 34.0926 286.441 24.4585 284.95C15.4238 283.566 7.39536 282.731 5.17594 285.992C0.958325 292.179 -1.13978 311.64 1.97883 316.907C3.69157 319.818 7.55236 317.749 13.3328 316.7C19.2703 315.644 26.8706 316.814 26.4353 317.999C26.0642 319.076 18.6352 320.09 12.5978 321.645C7.33113 323.016 2.57829 325.242 2.27856 326.305C1.33655 329.866 1.71478 344.575 4.13402 349.927C5.45426 352.846 12.8761 350.234 14.5175 354.68C16.0019 358.69 9.47205 361.502 10.9564 367.589C12.241 372.835 20.4336 377.566 29.7323 380.642Z"
        fill="#191D3A"
        transform="translate(7 9)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.7323 380.642C51.7552 387.921 61.8532 372.771 82.0207 360.318C99.7189 349.392 87.9724 331.058 99.4335 329.274C108.061 340.179 99.6047 355.707 113.685 364.4C127.786 373.077 122.919 345.317 133.046 333.37C146.398 317.62 143.151 301.863 149.303 287.205C154.105 275.808 144.072 247.834 150.059 224.526C157.888 194.054 171.732 209.29 176.871 194.46C181.224 181.208 164.624 182.193 178.212 160.72C189.324 143.171 191.721 133.901 205.63 121.776C217.263 111.586 212.688 90.369 225.155 86.6224C237.601 82.8401 236.645 90.5617 245.744 87.1434C254.814 83.7322 242.09 68.8884 256.035 63.3292C269.544 57.8984 274.875 78.9436 287.435 81.1773C309.458 85.1452 312.348 59.5255 324.808 54.6442C337.09 49.8343 357.614 76.2461 369.239 59.5255C377.917 47.0796 354.645 43.8183 353.575 38.2305C351.955 29.3742 372.479 24.8569 356.237 11.8544C344.405 2.37723 330.253 17.2923 325.186 14.3664C321.04 11.9828 323.188 0.0507644 297.176 0.471812C277.173 0.79295 268.488 12.9605 255.806 18.9979C242.954 25.1138 230.879 21.3743 221.359 30.8229C209.284 42.8192 219.525 49.2277 208.442 57.0706C201.834 61.6878 191.436 55.7503 170.419 64.9349C153.106 72.528 131.183 91.4181 134.231 98.69C137.328 105.926 181.795 86.08 181.738 94.2726C181.716 100.724 170.198 108.574 154.719 138.083C150.894 145.312 105.2 192.541 106.163 198.407C107.548 206.921 123.44 198.7 130.684 191.684C137.021 185.554 135.843 198.571 126.73 203.552C119.137 207.706 118.916 215.913 114.955 214.628C112.308 213.764 111.558 206.828 102.003 206.906C92.1187 207.006 81.7209 202.368 76.1902 205.536C69.4392 209.376 63.987 216.041 54.2315 220.565C39.6661 227.324 24.7796 233.097 18.8279 241.332C14.1178 247.855 4.28389 271.448 7.84495 276.501C10.3926 280.112 16.744 274.966 25.2007 278.727C30.817 281.211 47.1522 278.727 47.5947 280.504C47.9087 281.731 34.0926 286.441 24.4585 284.95C15.4238 283.566 7.39536 282.731 5.17594 285.992C0.958325 292.179 -1.13978 311.64 1.97883 316.907C3.69157 319.818 7.55236 317.749 13.3328 316.7C19.2703 315.644 26.8706 316.814 26.4353 317.999C26.0642 319.076 18.6352 320.09 12.5978 321.645C7.33113 323.016 2.57829 325.242 2.27856 326.305C1.33655 329.866 1.71478 344.575 4.13402 349.927C5.45426 352.846 12.8761 350.234 14.5175 354.68C16.0019 358.69 9.47205 361.502 10.9564 367.589C12.241 372.835 20.4336 377.566 29.7323 380.642Z"
        fill={props.isVisible ? "url(#bottom-to-top)" : "url(#top-to-bottom)"}
      />
    </svg>
  );
}
